import React from 'react';
import { FaFacebook, FaInstagram, FaTwitter, FaLinkedin, FaYoutube, FaPhone, FaEnvelope, FaMapMarkerAlt, FaWhatsapp } from 'react-icons/fa';

const iconMap = {
    facebook: FaFacebook,
    instagram: FaInstagram,
    twitter: FaTwitter,
    linkedin: FaLinkedin,
    youtube: FaYoutube,
    phone: FaPhone,
    envelope: FaEnvelope,
    mapMarker: FaMapMarkerAlt,
    whatsapp: FaWhatsapp
};

function Combo({ combo, isAlternate }) {

    return (
        <div className={`combo ${isAlternate ? 'alternate' : ''}`}>
            <div className='comboLeft'>
                <p>Benefícios Inclusos:</p>
                <div className='tagWrap'>
                    {combo.tags && combo.tags.map((tag, index) => {
                        const IconComponent = iconMap[tag.icone];
                        return (
                            <div key={index} className='tag'>
                                {IconComponent && <IconComponent />}
                                {tag.texto}
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className='comboRight'>
                {combo.titulo && <h1>{combo.titulo}</h1>}
                <hr />
                <div>
                    <p>R$</p>
                    {combo.valor && <h2>{combo.valor}</h2>}
                </div>

                <div className="Combos-Botao2">
                    <a style={{ textDecoration: 'none' }} href={combo.botoes.link} target="_blank" rel="noopener noreferrer">
                        <button>{combo.botoes.segundo}</button>
                    </a>
                </div>

            </div>
        </div>
    );
}

export default Combo;
